import { render } from "./widget-notebook.vue?vue&type=template&id=e58672b0"
import script from "./widget-notebook.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-notebook.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/widgets/widget-notebook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e58672b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e58672b0', __exports__)) {
    api.reload('e58672b0', __exports__)
  }
  
  module.hot.accept("./widget-notebook.vue?vue&type=template&id=e58672b0", () => {
    api.rerender('e58672b0', render)
  })

}


export default __exports__